import React, { useEffect, useState } from 'react';
import '../chat/Userstyle.css';
import chatbotIcon from '../chat/images/chatbox-icon.svg';
import chatsupportIcon from '../chat/images/chatbot (1).png';
import '../chat/adminstyle.css';
import { json, Route } from 'react-router';
import { use } from 'react';
import { Margin, X } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { endpoint } from '../../../resource/Constant';
import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';

//to get the user and chatbot messages
const message = [];
let decode_file = [];
export const AdminChatApp = () => {
  //using state hook to dynamically open or close chatbot and get input field
  const [isOpen, SetIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const token = params.token;
  const useremail = params.useremail;
  const spring_token = params.jwt;
  //set
  //1:messages
  //2:upload
  //3:files
  //4:addapikey
  const [display, setDisplay] = useState(1);
  const [file_names, setFile_Names] = useState([]);
  const [menu, setMenu] = useState(false);
  const [newApiKey, setNewApiKey] = useState('');
  const [accountInfo, setAccountInfo] = useState({});
  const header = { Authorization: 'Bearer ' + token };

  //get the token

  const getCompanyData = () => {
    setLoading(true);
    axios
      .get(endpoint + '/api/aichatbot/company', { headers: header })
      .then((res) => {
        setAccountInfo(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        const error = err?.response?.data?.detail ? err?.response?.data?.detail : 'Something went wrong.';
        toast.error(`${error}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    getCompanyData();
  }, []);
  //sendmessage function to call the api and get the response
  const sendMessage = async () => {
    const chatbox = document.querySelector('.chatbox__support');
    const varfield = document.querySelector('input');

    //try and catch block
    try {
      // Fetching the response from the server
      const response = await fetch(`${endpoint}/api/aichatbot`, {
        // api endpoint
        method: 'POST', // method of api
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        mode: 'cors', // cross origin
        body: JSON.stringify({
          message: input,
          user_email: useremail,
          springboot_token: spring_token // always required for authentication
        })
      });

      if (!response.ok) {
        message.pop();
        message.push('Sorry, I am not able to connect to the server. Please try again later.');
        updatChattext(chatbox);
        throw new Error(`Http error! statuds ${response.status}`);
      }

      // Extracting the json from the response
      const json = await response.json();
      //push the message based on given by chatbot or admin
      if (json.message.result) {
        message.pop();
        message.push(json.message.result);
      } else {
        message.pop();
        message.push(json.message);
      }
      setInput('');
      updatChattext(chatbox);
      varfield.value = '';
    } catch (error) {
      // Catching the error
      updatChattext(chatbox);
      varfield.value = '';
    }
  };

  // handleSendMessage function to handle the send function and calling sendMessage function
  const handleSendMessage = () => {
    const chatbox = document.querySelector('.chatbox__support');
    let varfield = chatbox.querySelector('input');

    if (varfield.value === '') {
      varfield.placeholder = 'Please enter a message';
      return;
    }
    let user = {
      // message given me user
      name: 'User',
      message: input
    };
    message.push(user);
    message.push('Typing');
    varfield.value = '';
    updatChattext(chatbox);
    sendMessage();
  };

  // updateChattext to update the message function and traverse
  const updatChattext = (chatbox) => {
    var html = '';
    message
      .slice()
      .reverse()
      .map((msg) => {
        // using the js map function to traverse in reverse order to get the latest message
        if (msg === 'Typing') {
          html += `<div style="font-weight: 600;">
            <span id="loading" class="typing-dots"><span class="dots"></span></span>
            </div>`;
          // html += `<div id="loading"></div>`;
        } else if (msg.name === 'User') {
          html += '<div class="messages__item messages__item--operator">' + msg.message + '</div>';
        } else {
          html += '<div class="messages__item messages__item--visitor">' + msg + '</div>';
        }
      });
    const chatmessage = chatbox.querySelector('.chatbox__messages');
    chatmessage.innerHTML = html;
  };

  //toggleChatbot function to open and close the chatbot
  const togglechatbot = () => {
    SetIsOpen((prev) => {
      if (!prev) {
        // localStorage.setItem("aichabotspecs",JSON.stringify({height:700,width:500}))
      } else {
        // localStorage.setItem("aichabotspecs",JSON.stringify({height:500,width:700}))
      }
      return !prev;
    });
  };
  useEffect(() => {
    const chatbox = document.querySelector('.chatbox__support');
    if (isOpen) {
      chatbox.classList.add('chatbox--active');
    } else {
      chatbox.classList.remove('chatbox--active');
    }
  }, [isOpen]);

  //****************************************
  // const [showmessage, setShowMessage] = useState(true);
  // const [showupload, setShowUpload] = useState(false);
  // const [showfiles, setShowFiles] = useState(false);

  //getting the html elements
  // const el = document.querySelector(".more");
  // const btn = document.querySelector(".more .more-btn");
  // const menu = document.querySelector(".more .more-menu");

  //calling an endpoint to upload file
  const UploadFile = async () => {
    setDisplay(2);
    //html file element
    const fileInput = document.getElementById('myFile');

    //getting the files user selected
    const file = fileInput.files[0];

    //check file selected or not
    if (!file) {
      return;
    }

    //Create a form data object to append a file
    const formdata = new FormData();
    formdata.append('file', file);
    setLoading(true);
    //calling upload file endpoint
    await fetch(`${endpoint}/api/aichatbot/uploadfile`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: formdata
    })
      .then((res) => {
        setLoading(false);
        getFiles();
        // alert("File Uploaded Successfully");
      })
      .catch((err) => {
        // alert("Error uploading file.");
      });
  };

  const getFiles = async () => {
    setMenu(false);
    setDisplay(3);
    setLoading(true);
    axios
      .get(`${endpoint}/api/aichatbot/list_files`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((res) => {
        setFile_Names(res?.data?.files);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const convertFileName = (file) => {
    if (file.length > 15) {
      let normal_name = file;
      let encode_name = file.slice(0, 15) + '...pdf';
      let names = {
        [encode_name]: normal_name
      };
      decode_file.push(names);
      return encode_name;
    } else {
      return file;
    }
  };

  const handleDeleteButtonClick = (file_name) => {
    //encodeurl because url not takes whitespace and special character
    //to replace that with hexadicemal value
    const urlSafeFileName = encodeURIComponent(file_name);
    //delete file function to call the ap
    setLoading(true);
    fetch(`${endpoint}/api/aichatbot/delete_file?file_name=${urlSafeFileName}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(() => {
        setLoading(false);
        getFiles();
      })
      .catch(() => {
        setLoading(false);
      });

    //if api give code 200 then show the alert of successfull
  };
  const handleApiKeyChange = () => {
    if (newApiKey.length === 0) {
      return;
    }
    setLoading(true);
    const param = {
      open_api_key: newApiKey
    };
    axios
      .put(endpoint + '/api/aichatbot/addapikey', null, { headers: header, params: param })
      .then((res) => {
        toast.success(`OpenAI API Key Updated`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setNewApiKey('');
        setLoading(false);
      })
      .catch((err) => {
        const error = err?.response?.data?.detail ? err?.response?.data?.detail : 'Something went wrong.';
        toast.error(`${error}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };

  //to handle the uplaod file
  const handleUploadFile = () => {
    setDisplay(2);
    setMenu(false);
  };

  const handleChatbotClick = () => {
    setMenu(false);
    setDisplay(1);
  };

  //showmenu to show the more option and hide
  const toggleMenu = () => {
    setMenu((prev) => !prev);
  };

  //hideMenu to hide the more options menu

  //************************************************
  return (
    <>
      <div className="chatbot" style={{ background: 'black', backgroundColor: 'transparent' }}>
        <div className="chatbox">
          {/* Chatbox content */}
          <div className="chatbox__support">
            <div className="chatbox__header">
              <div className="chatbox__image--header">
                <img style={{ width: '35px', height: '35px' }} src={chatsupportIcon} alt="Chat Icon" />
              </div>
              <div className="chatbox__content--header">
                <h4 className="chatbox__heading--header">DataDrivenAI</h4>
              </div>
              {/* **************************************** */}
              <div className="more">
                <button id="more-btn" className="more-btn" style={{ marginLeft: '100px' }} onClick={toggleMenu}>
                  <span className="more-dot"></span>
                  <span className="more-dot"></span>
                  <span className="more-dot"></span>
                </button>
                {menu ? (
                  <div className="more-menu">
                    <ul className="more-menu-items">
                      <li className="more-menu-item">
                        <button
                          id="chatbot"
                          className="more-menu-btn"
                          onClick={handleChatbotClick}
                          // disabled = {isDisabled}
                        >
                          Chatbot
                        </button>
                      </li>
                      <li className="more-menu-item">
                        <button
                          // disabled = {isDisabled}
                          id="upload"
                          className="more-menu-btn"
                          onClick={handleUploadFile}
                        >
                          Upload File
                        </button>
                      </li>
                      <li className="more-menu-item">
                        <button
                          // disabled = {isDisabled}
                          id="list"
                          className="more-menu-btn"
                          onClick={getFiles}
                        >
                          Files
                        </button>
                      </li>
                      <li className="more-menu-item">
                        <button
                          // disabled = {isDisabled}
                          id="list"
                          className="more-menu-btn"
                          onClick={() => {
                            setDisplay(4);
                            setMenu(false);
                          }}
                        >
                          Open-AI Key
                        </button>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* *********************************** */}
            </div>
            {display === 3 && (
              <div className="">
                {file_names.length === 0 ? (
                  <p>No Files available</p>
                ) : (
                  file_names.map((file, index) => {
                    return (
                      <div key={index} className="messages__item messages__item--visitor" style={{ width: '100%' }}>
                        <span id={`spn${index}`} className="file_name">
                          {convertFileName(file)}
                        </span>
                        <button
                          className="delete-btn"
                          onClick={() => {
                            handleDeleteButtonClick(file);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    );
                  })
                )}
                <Backdrop open={loading}>
                  <svg width={0} height={0}>
                    <defs>
                      <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
                </Backdrop>
              </div>
            )}
            {display === 2 && (
              <div
                style={{
                  padding: '20px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  maxWidth: '400px',
                  margin: '20px auto',
                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                  backgroundColor: '#fff',
                  fontFamily: "'Roboto', sans-serif"
                }}
              >
                <h3
                  style={{
                    paddingBottom: '10px',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    color: '#212121',
                    textAlign: 'center',
                    borderBottom: '2px solid #f0f0f0',
                    marginBottom: '20px'
                  }}
                >
                  Upload File
                </h3>
                <input
                  accept=".pdf"
                  type="file"
                  id="myFile"
                  name="filename"
                  style={{
                    display: 'block',
                    margin: '0 auto 20px auto',
                    padding: '10px',
                    fontSize: '14px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    width: '100%',
                    backgroundColor: '#fafafa',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                  onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
                />
                <button
                  style={{
                    display: 'block',
                    margin: '10px auto',
                    padding: '12px 20px',
                    background: 'linear-gradient(90deg, #6a11cb, #2575fc)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease'
                  }}
                  className="btn btn-primary"
                  id="submitFile"
                  onClick={UploadFile}
                  type="submit"
                  onMouseOver={(e) => (e.target.style.transform = 'scale(1.05)')}
                  onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
                >
                  Submit
                </button>
                <Backdrop open={loading}>
                  <svg width={0} height={0}>
                    <defs>
                      <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
                </Backdrop>
              </div>
            )}
            {display === 4 && (
              <div
                style={{
                  padding: '20px',
                  border: '1px solid #e0e0e0',
                  borderRadius: '12px',
                  maxWidth: '400px',
                  margin: '20px auto',
                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                  backgroundColor: '#fff',
                  fontFamily: "'Roboto', sans-serif"
                }}
              >
                <h3
                  style={{
                    paddingBottom: '10px',
                    fontWeight: 'bold',
                    fontSize: '20px',
                    color: '#212121',
                    textAlign: 'center',
                    borderBottom: '2px solid #f0f0f0',
                    marginBottom: '20px'
                  }}
                >
                  Add OpenAI Key
                </h3>
                <input
                  value={newApiKey}
                  type="text"
                  placeholder="OpenAi Api key"
                  style={{
                    display: 'block',
                    margin: '0 auto 20px auto',
                    padding: '10px',
                    fontSize: '14px',
                    borderRadius: '6px',
                    border: '1px solid #e0e0e0',
                    width: '100%',
                    backgroundColor: '#fafafa',
                    outline: 'none',
                    transition: 'border-color 0.3s ease'
                  }}
                  onChange={(e) => {
                    setNewApiKey(e.target.value);
                  }}
                  onFocus={(e) => (e.target.style.borderColor = '#007bff')}
                  onBlur={(e) => (e.target.style.borderColor = '#e0e0e0')}
                />
                <button
                  style={{
                    display: 'block',
                    margin: '10px auto',
                    padding: '12px 20px',
                    background: 'linear-gradient(90deg, #6a11cb, #2575fc)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                    transition: 'all 0.3s ease'
                  }}
                  className="btn btn-primary"
                  onClick={handleApiKeyChange}
                  type="submit"
                  onMouseOver={(e) => (e.target.style.transform = 'scale(1.05)')}
                  onMouseOut={(e) => (e.target.style.transform = 'scale(1)')}
                >
                  Submit
                </button>
                <Backdrop open={loading}>
                  <svg width={0} height={0}>
                    <defs>
                      <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                      </linearGradient>
                    </defs>
                  </svg>
                  <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
                </Backdrop>
              </div>
            )}
            {display === 1 && (
              <div className="chatbox__messages">
                {/* <!-- Example messages --> */}
                <div className="messages__item messages__item--visitor">Hello! How can I help you today?</div>
                <div className="messages__item messages__item--operator">I need assistance with my account.</div>
              </div>
            )}
            {display === 1 && (
              <div className="chatbox__footer">
                <form>
                  <input
                    style={{ width: '240px' }}
                    id="messageField"
                    type="text"
                    autocomplete="off"
                    placeholder="Type your message..."
                    value={input}
                    onChange={(e) => {
                      setInput(e.target.value);
                    }}
                  />
                  <button type="submit" className="chatbox__send--footer send__button" onClick={handleSendMessage}>
                    Send
                  </button>
                </form>
              </div>
            )}
          </div>
          {/* Chatbox toggle button */}
          <div className="chatbox__button">
            <button onClick={togglechatbot}>
              <img src={chatbotIcon} alt="Chat Icon" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminChatApp;
